const ActivityTypeLabelsStudents = {
  song: 'song',
  video: 'video',
  craft: 'craft',
  pictureDictionary: 'picture dictionary',
  interactiveVideo: 'video with questions',
  game: {
    classic: {
      dragAndMatch: 'Drag & Match game',
      conceptRace: 'Concept Race game',
      memoryGame: 'Memory game',
    },
    bubbles: 'bubbles game',
    quiz: 'quiz game',
    imagesQuiz: 'images quiz game',
    skate: 'skateboard game',
    conceptRace: 'Concept Race game',
    sortImages: {
      training: 'Training',
      conceptQuest: 'Listen & Match',
    },
  },
  worksheet: 'worksheet',
  shortStory: {
    story: 'Short Story slides',
    sequencing: 'Short Story sequencing',
    quiz: 'Short Story quiz',
  },
  external: 'Instructions',
  realTime: {
    sortImages: 'Listen & Match',
  },
  comic: 'comic',
  storyWithQuestions: {
    [undefined]: 'Story with questions',
    story: 'Story',
    quiz: 'Story with questions',
  },
};
export default function typeLabel(type, subType, miniactivityType) {
  return (
    ActivityTypeLabelsStudents[type]?.[miniactivityType] ??
    ActivityTypeLabelsStudents[type]?.[subType]?.[miniactivityType] ??
    ActivityTypeLabelsStudents[type]?.[subType] ??
    ActivityTypeLabelsStudents[type]
  );
}
